import AnnouncementBar from '../home/components/AnnouncementBar';
import Navbar from '../home/components/Navbar';
import FooterSection from '../home/components/FooterSection';
import SEOHead from '../../components/feature/SEOHead';
import { SITE_URL } from '../../utils/seo';

const pillars = [
  { label: 'Ultra-birleşik' },
  { label: 'Ultra-güvenli' },
  { label: 'Ultra-ölçeklenebilir' },
  { label: 'Ultra-ekonomik' },
];

const causes = [
  { q: 'Bakım süresi doldu mu?', a: 'VergeOS on yıllarca değil, on yıllarca çalışır!' },
  { q: 'Performans veya kapasite ihtiyaçlarını karşılayamıyor mu?', a: 'VergeIO kapasiteyi ve performansı bağımsız ve sonsuz olarak ölçeklendirebilir.' },
  { q: 'Yeni donanım yeniliklerinden yararlanamıyor mu?', a: 'VergeIO eski ve modern yenilikleri eş zamanlı olarak destekleyebilir.' },
];

const storageFeatures = [
  { icon: 'ri-file-copy-line', title: 'Değişmez, Anlık Klonlar ve Anlık Görüntüler', desc: 'Fidye yazılımına dayanıklı değişmez anlık görüntüler ve anlık klonlar.' },
  { icon: 'ri-cpu-line', title: 'Global Satır İçi Veri Tekilleştirme', desc: 'Her zaman aktif, her yerde çalışan global tekilleştirme.' },
  { icon: 'ri-lock-line', title: '256-bit Dinlenme Halinde Veri Şifreleme', desc: 'Kurumsal sınıf veri güvenliği, yerleşik şifreleme.' },
  { icon: 'ri-shield-check-line', title: 'Yerleşik Yedekleme ve Koruma', desc: 'Sürücü, düğüm veya site arızasından tam koruma.' },
  { icon: 'ri-database-2-line', title: 'Birleşik Depolama', desc: 'SAN ve NAS\'ı tek çözümde birleştirin.' },
];

const sanJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'VergeOS SAN/NAS Değiştirme',
  applicationCategory: 'BusinessApplication',
  operatingSystem: 'Any',
  description: 'Pahalı SAN/NAS sistemleri yerine VergeOS ile birleşik depolama. Global tekilleştirme, değişmez anlık görüntüler, 256-bit şifreleme ve birleşik SAN+NAS.',
  url: `${SITE_URL}/san-replacement`,
};

export default function SANReplacementPage() {
  return (
    <div className="min-h-screen w-full bg-white">
      <SEOHead
        title="SAN ve NAS Değiştirme | VergeOS Birleşik Depolama"
        description="VergeOS ile pahalı SAN/NAS sistemlerini değiştirin. Global tekilleştirme, değişmez anlık görüntüler, 256-bit şifreleme ve birleşik SAN+NAS çözümü."
        keywords="SAN değiştirme, NAS değiştirme, depolama yenileme, VergeOS, birleşik depolama, SAN alternatifi"
        canonicalPath="/san-replacement"
        jsonLd={sanJsonLd}
      />
      <AnnouncementBar />
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative w-full overflow-hidden bg-[#0f1117] py-24 text-center">
          <div className="absolute inset-0 opacity-20" style={{ backgroundImage: 'repeating-linear-gradient(45deg,#e8600a 0,#e8600a 1px,transparent 0,transparent 50%)', backgroundSize: '20px 20px' }} />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0f1117]/60 to-[#0f1117]/90" />
          <div className="relative z-10 max-w-4xl mx-auto px-6">
            <div className="inline-block bg-[#e8600a]/20 text-[#e8600a] text-xs font-semibold uppercase tracking-widest px-4 py-1.5 rounded-full mb-6">BT Girişimleri</div>
            <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4 leading-tight">
              SAN veya NAS'ınızı <span className="text-[#e8600a]">Değiştirin</span>
            </h1>
            <p className="text-xl text-gray-300 mb-3 font-medium">VergeIO'nun Ultraconverged Altyapısı ile</p>
            <div className="flex flex-wrap justify-center gap-3 mb-8">
              {pillars.map(p => (
                <span key={p.label} className="bg-[#e8600a]/20 text-[#e8600a] text-xs font-semibold px-4 py-1.5 rounded-full">{p.label}</span>
              ))}
            </div>
          </div>
        </section>

        {/* Causes */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-16 items-center">
              <div>
                <h2 className="text-3xl font-bold text-[#1e293b] mb-6">SAN/NAS Değiştirme Nedenlerini Ortadan Kaldırın</h2>
                <p className="text-gray-600 mb-6 leading-relaxed">Çoğu SAN veya NAS depolama sistemi her dört ila beş yılda bir değiştirilmek veya yenilenmek zorundadır. Kuruluşların genellikle beş ila altı depolama silosu bulunur ve bu durum sürekli donanım satın alımı ve veri migrasyonu döngüsü yaratır. VergeIO bunu değiştiriyor.</p>
                <div className="space-y-4">
                  {causes.map(c => (
                    <div key={c.q} className="bg-[#f8fafc] rounded-lg p-5 border border-gray-100">
                      <p className="font-semibold text-[#1e293b] mb-2 text-sm">{c.q}</p>
                      <p className="text-sm text-[#e8600a] font-medium">{c.a}</p>
                    </div>
                  ))}
                </div>
              </div>
              <div className="rounded-xl overflow-hidden">
                <img src="https://public.readdy.ai/ai/img_res/2781d0d5b11bb94bd09e6eab08019d8e.jpg" alt="SAN Değiştirme Döngüsü" className="w-full h-full object-top" />
              </div>
            </div>
          </div>
        </section>

        {/* Advanced Storage */}
        <section className="py-20 bg-[#f8fafc]">
          <div className="max-w-6xl mx-auto px-6">
            <h2 className="text-3xl font-bold text-[#1e293b] text-center mb-12">Gelişmiş Depolama Özellikleri</h2>
            <div className="grid md:grid-cols-3 lg:grid-cols-5 gap-4">
              {storageFeatures.map(f => (
                <div key={f.title} className="bg-white rounded-lg border border-gray-100 p-5 text-center">
                  <span className="w-10 h-10 flex items-center justify-center bg-[#e8600a]/10 rounded-lg text-[#e8600a] mx-auto mb-3"><i className={`${f.icon} text-xl`}></i></span>
                  <h3 className="font-semibold text-[#1e293b] mb-2 text-xs">{f.title}</h3>
                  <p className="text-xs text-gray-600">{f.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Consolidate */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-16 items-center">
              <div className="rounded-xl overflow-hidden">
                <img src="https://readdy.ai/api/search-image?query=VergeOS%20workload%20consolidation%20showing%20multiple%20storage%20silos%20being%20replaced%20by%20unified%20infrastructure%20platform%2C%20deduplication%20WAN%20optimized%20remote%20sync%20and%20immutable%20snapshots%20diagram%2C%20dark%20background%20orange%20highlights%20professional%20enterprise%20storage%20visualization&width=580&height=400&seq=san_consolidate1&orientation=landscape" alt="İş Yükü Konsolidasyonu" className="w-full h-full object-top" />
              </div>
              <div>
                <h2 className="text-3xl font-bold text-[#1e293b] mb-6">İş Yüklerini Tek İşletim Ortamında Birleştirin</h2>
                <p className="text-gray-600 mb-6 leading-relaxed">VergeIO ile iş yüklerini, veri hizmetlerini iyileştirirken tek bir işletim ortamında birleştirebilirsiniz:</p>
                <ul className="space-y-3 mb-6">
                  {[
                    'Global satır içi veri tekilleştirme ile kapasite gereksinimlerini azaltın',
                    'Daha az yüksek performanslı verileri daha düşük maliyetli sabit disk sürücülerinde yerleştirerek maliyetleri daha da düşürün',
                    'Veri kullanılabilirliğini, korumasını ve kurtarma yeteneklerini iyileştirin',
                    'Firmware benzeri yazılım ortamı saldırılara karşı sertleştirir',
                    'Fidye yazılımı kurtarma için sık, değişmez anlık görüntüler sağlar',
                  ].map(item => (
                    <li key={item} className="flex items-start gap-2 text-sm text-gray-700">
                      <i className="ri-check-line text-[#e8600a] text-base shrink-0 mt-0.5"></i>{item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>
      </main>
      <FooterSection />
    </div>
  );
}
